import { render, staticRenderFns } from "./alunos-pendentes.vue?vue&type=template&id=4994abd3"
import script from "./alunos-pendentes.vue?vue&type=script&lang=js"
export * from "./alunos-pendentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports